import { Banner, Button } from '@zoom/react-ui'
import {
  useAppDispatch,
  useAppSelector,
  useSelectOrigin,
  useSelectRunningContext,
} from '../hooks'
import { selectCollaborationId, setIsNavigatingDuringCollab } from '../app/root'
import { useCallback } from 'react'
import { setDialog } from '../app/dialog'

const CollaborationBanner = () => {
  // const app = useAppSelector(selectApp) as App
  const dispatch = useAppDispatch()
  const origin = useSelectOrigin()
  const runningContext = useSelectRunningContext()
  const collaborationId = useAppSelector(selectCollaborationId)

  /* Microsoft Native Code
    const onButtonClick = useCallback(() => {
    if (
      origin === 'Meeting Chat' &&
      runningContext === 'inCollaborate' &&
      app === 'Google' &&
      collaborationId === undefined
    ) {
      dispatch(setDialog({ type: 'joinError' }))
    } else dispatch(setIsNavigatingDuringCollab(false))
  }, [dispatch, runningContext, origin, app, collaborationId])
  */
  const onButtonClick = useCallback(() => {
    if (
      origin === 'Meeting Chat' &&
      runningContext === 'inCollaborate' &&
      collaborationId === undefined
    ) {
      dispatch(setDialog({ type: 'joinError' }))
    } else dispatch(setIsNavigatingDuringCollab(false))
  }, [dispatch, runningContext, origin, collaborationId])

  return (
    <Banner
      type='info'
      closable={false}
      content='Active collaboration in progress'
      sx={{
        '.MuiAlert-message': {
          display: 'flex !important',
          alignItems: 'center',
        },
        '.ui-Banner-action-btn-group': {
          marginTop: '0px !important',
        },
        '.ui-Banner-icon-wrapper': {
          alignSelf: 'center',
        },
      }}
      className='whitespace-nowrap'
      action={
        <Button
          size='medium'
          type='tertiary'
          onClick={onButtonClick}
        >
          Join
        </Button>
      }
    />
  )
}

export default CollaborationBanner
